import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/providers/ThemeProvider";
import { useEffect, useState } from "react";
import { Button } from "@radix-ui/themes";

export function ThemeToggle() {
  const { isDarkMode, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Prevent hydration mismatch by only rendering after mount
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div style={{ width: "36px", height: "36px" }} />; // Placeholder with same dimensions
  }

  return (
    <Button
      variant="ghost"
      size="2"
      onClick={toggleTheme}
      style={{ cursor: "pointer" }}
      aria-label="Toggle theme"
    >
      {isDarkMode ? (
        <Sun style={{ width: "20px", height: "20px" }} />
      ) : (
        <Moon style={{ width: "20px", height: "20px" }} />
      )}
    </Button>
  );
}
